import styled, { css } from "styled-components";

export const Container = styled.div`
  height: calc(100vh - 8.4rem);
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  ${({ isAccountPremium }) =>
    !isAccountPremium &&
    css`
      overflow-y: hidden;
      main {
        filter: blur(3px);
      }
    `}
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.6rem 0;
  width: 100%;

  .label {
    font-size: 1.4rem;
    text-transform: capitalize;
  }
`;

export const TogglesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 2.4rem;
`;

export const PreviewTextarea = styled.textarea`
  width: 100%;
  min-height: 20rem;
  resize: vertical;
  padding: 1.2rem;
  font-size: 1.4rem;
  font-family: inherit;
  border-radius: 4px;
  border: 1px solid #404040;
  background-color: #0a0a0a;
  color: #ecfeff;
  margin-bottom: 1.6rem;
`;

export const CopyButtonWrapper = styled.div`
  ${({ copied }) =>
    copied &&
    css`
      button {
        background-color: transparent !important;
        color: #00ff15 !important;
      }
    `}
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

export const CopyFeedback = styled.span`
  font-size: 1.4rem;
  color: #d97706;
`;
